import Svg, { Path } from 'react-native-svg'

const CloseIconWhiteSVG = () => {
  return (
    <Svg width={24} height={24} fill="none" viewBox="0 0 24 24">
      <Path
        id="Vector"
        d="M19.5459 17.9541C19.7573 18.1654 19.876 18.4521 19.876 18.751C19.876 19.0499 19.7573 19.3365 19.5459 19.5479C19.3346 19.7592 19.0479 19.8779 18.7491 19.8779C18.4502 19.8779 18.1635 19.7592 17.9522 19.5479L12 13.5938L6.04593 19.546C5.83458 19.7573 5.54794 19.8761 5.24905 19.8761C4.95017 19.8761 4.66352 19.7573 4.45218 19.546C4.24083 19.3346 4.1221 19.048 4.1221 18.7491C4.1221 18.4502 4.24083 18.1636 4.45218 17.9522L10.4062 12L4.45405 6.04598C4.24271 5.83464 4.12398 5.54799 4.12398 5.2491C4.12398 4.95022 4.24271 4.66357 4.45405 4.45223C4.6654 4.24089 4.95204 4.12215 5.25093 4.12215C5.54981 4.12215 5.83646 4.24089 6.0478 4.45223L12 10.4063L17.9541 4.45129C18.1654 4.23995 18.452 4.12122 18.7509 4.12122C19.0498 4.12122 19.3365 4.23995 19.5478 4.45129C19.7591 4.66264 19.8779 4.94928 19.8779 5.24817C19.8779 5.54705 19.7591 5.8337 19.5478 6.04504L13.5937 12L19.5459 17.9541Z"
        fill="#F5F5ED"
      />
    </Svg>
  )
}

export default CloseIconWhiteSVG
